/*global _ */
const prefix = 'profile.orders.table'
export default (Bus) => {
  Bus.add(`${prefix}.cell-component-attrs`, modifyCellComponentAttrs)
  Bus.add(`${prefix}.cell-component`, modifyCellComponent)
}

const voucherProducts = ['playcard_sale', 'playcard_voucher', 'playcard']

// detect whether item has voucher asset
const modifyCellComponentAttrs = (params) => {
  //{value, component, row, data, column, index, rowIndex, vm}
  const {column, row} = params
  if (column.name === 'details') {
    const isHavingVoucher = _.some(_.get(row, 'items.data'), (item) => {
      return voucherProducts.includes(_.get(item, 'product.data.type'))
    })
    if (isHavingVoucher) {
      _.set(params, 'value.title', column.voucherTitle)
    }
  }
}

// Prevent showing order invoice button for failed orders
const modifyCellComponent = (params) => {
  //{value, data, row, column, index, rowIndex, vm}
  const failedStates = ['failed', 'failing']
  const {column, row} = params
  if (column.name === 'details') {
    if (failedStates.includes(row.state)) {
      params.value = null
      row.invoice_url = ''
    }
  }
}
